export const APP_NAME = 'Elstar';
export const APP_LOGO_COLOR_LG = '/brand/link-p-logo-lg.png';
export const APP_LOGO_COLOR_SM = '/brand/link-p-logo-sm.jpg';

export const PERSIST_STORE_NAME = 'admin';
export const REDIRECT_URL_KEY = 'redirectUrl';
